<ng-container *transloco="let t">
  <app-page-template [showBreadcrumbs]="false">
    <div class="container">
      <div class="row">
        <div class="col">
          <app-styled-header-box
            [text]="calendarType === EventItemType.FINISHED ? t('event.calendar.finished.events') : t('event.calendar.event.calendar')"
            [withBackground]="withBackground">
          </app-styled-header-box>
        </div>
      </div>
      <ng-template [ngTemplateOutlet]="searchFrom"></ng-template>
    </div>
    <!--    @if (eventMapVisible) {-->
    <!--      <ng-template [ngTemplateOutlet]="eventMap"></ng-template>-->
    <!--    }-->
    <ng-template [ngTemplateOutlet]="eventList"></ng-template>

  </app-page-template>

  <ng-template #searchFrom>
    <app-public-search-filter [filterBy]="['sports', 'country', 'length']"
                              [countries]="countriesForSearch"
                              [sports]="sportsForSearch"
                              [disablePastMonths]="calendarType === EventItemType.UPCOMING"
                              [disableFutureMonths]="calendarType === EventItemType.FINISHED"
                              [lengthRanges]="lengthRanges"
                              [handleQueryParamsChange]="true"
                              (onFilterChange)="filterChanged($event)">

    </app-public-search-filter>
  </ng-template>

  <ng-template #eventList>
    <div class="padding-bottom-92 pb-300-100">
      <section class="next-race-section">
        <div class="container">
          @if (listOfEvents.length ?? 0 > 0) {
            <app-event-grid-list [events]="listOfEvents!"
                                 (scrolled)="loadMore()"
                                 (onRightButtonClickCallback)="goToEventDetailsPage($event)"
                                 [languages]="languages"/>
          } @else {
            <app-empty-state/>
          }
        </div>
      </section>
    </div>
  </ng-template>

  <ng-template #eventMap>
    <div>
      <section class="pb-300-100">
        <div class="container">
          <app-loader [isLoading]="isLoading"></app-loader>
          <section>
            <app-leaflet-maps-wrapper [lat]="lat" [lng]="lng" [points]="waypointList" [languages]="languages"
                                      [countries]="countries" [mapOnEventCalendar]="true" [increaseMapHeight]="true"/>
          </section>
        </div>
      </section>
    </div>
  </ng-template>

</ng-container>
